import { AppActionTypes, ApplicationActions } from '../store/application-actions';

export function onCloseDeleteDialog(dispatch: React.Dispatch<ApplicationActions>): void {
  dispatch({ type: AppActionTypes.SET_CONVERSATION_TO_DELETE, payload: '' });
  dispatch({ type: AppActionTypes.START_CONVERSATION });
}
